export default __webpack_public_path__ + "static/media/photo--sm--61.d0e3d049.jpg";